"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPaymentupdateStatus = void 0;
var IPaymentupdateStatus;
(function (IPaymentupdateStatus) {
    IPaymentupdateStatus["THE_PAYMENTUPDATE_WAS_SENT_AND_IS_PENDING_TO_BE_PROCESSED_PENDING"] = "pending";
    IPaymentupdateStatus["THE_PAYMENTUPDATE_WAS_RECEIVED_AND_IS_PROCESSING_PROCESSING"] = "processing";
    IPaymentupdateStatus["_FAILED"] = "failed";
    IPaymentupdateStatus["THE_PAYMENTUPDATE_WAS_PROCESSED_PROCESSED"] = "processed";
})(IPaymentupdateStatus = exports.IPaymentupdateStatus || (exports.IPaymentupdateStatus = {}));
